const shades = {
  white000: '#ffffff',
  black900: '#212121',
  black700: '#424242',
  grey50: '#f7f8f9',
  grey100: '#e7e9ed',
  grey200: '#cdd3d9',
  grey300: '#9fabb7',
  grey400: '#8191a1',
  grey500: '#64788b',
  grey600: '#556676',
  grey700: '#465461',
  grey800: '#37424C',
  grey900: '#283038',
};

const colourShades = {
  green950: '#133F34',
  green900: '#1F5837',
  green800: '#276939',
  green700: '#36893D',
  green600: '#3E9A40',
  green500: '#4DBB44',
  green400: '#71C969',
  green300: '#94D68F',
  green200: '#B8E4B4',
  green100: '#D2EED0',
  green50: '#EDF8EC',

  blue950: '#0A375E',
  blue900: '#104B7A',
  blue800: '#14598D',
  blue700: '#1C73B4',
  blue600: '#2080C7',
  blue500: '#289BED',
  blue400: '#53AFF1',
  blue300: '#7EC3F4',
  blue200: '#A9D7F8',
  blue100: '#C9E6FB',
  blue50: '#E9F5FD',

  yellow950: '#3F4324',
  yellow900: '#645E1E',
  yellow800: '#7D701A',
  yellow700: '#AF9311',
  yellow600: '#C8A50D',
  yellow500: '#FAC905',
  yellow400: '#FBD437',
  yellow300: '#FCDF69',
  yellow200: '#FDE99B',
  yellow100: '#FEF1C0',
  yellow50: '#FEFAE6',

  orange950: '#40312C',
  orange900: '#66412B',
  orange800: '#804C2B',
  orange700: '#B26129',
  orange600: '#CC6C28',
  orange500: '#FF8127',
  orange400: '#FF9A52',
  orange300: '#FFB37D',
  orange200: '#FFCDA9',
  orange100: '#FFDFC9',
  orange50: '#FFF2E9',

  pink950: '#40253B',
  pink900: '#662E42',
  pink800: '#803447',
  pink700: '#B24051',
  pink600: '#CC4656',
  pink500: '#FF5260',
  pink400: '#FF7580',
  pink300: '#FF97A0',
  pink200: '#FFBABF',
  pink100: '#FFD4D7',
  pink50: '#FFEEEF',

  purple950: '#293359',
  purple900: '#424573',
  purple800: '#535184',
  purple700: '#7468A6',
  purple600: '#8474B8',
  purple500: '#A58BDA',
  purple400: '#B7A2E1',
  purple300: '#C9B9E9',
  purple200: '#DBD1F0',
  purple100: '#E9E2F6',
  purple50: '#F6F3FB',

  teal950: '#023E50',
  teal900: '#045565',
  teal800: '#056573',
  teal700: '#06858E',
  teal600: '#07949C',
  teal500: '#09B4B7',
  teal400: '#3AC3C5',
  teal300: '#6BD2D4',
  teal200: '#9DE1E2',
  teal100: '#C1ECED',
  teal50: '#E6F7F8',
};
/**
 * These are used directly, they will be changed to named later on as part of design system update.
 */
const unnamedShades = {
  ...shades,
  red50: '#faeced',
  red100: '#f1c4c6',
  red200: '#eaa8aa',
  red300: '#e08084',
  red400: '#da686c',
  red500: '#d14247',
  red600: '#be3c41',
  red700: '#942f32',
  red800: '#732427',
  red900: '#581c1e',
  green50: '#ecf7f1',
  green200: '#a5dabd',
  green300: '#7cc99f',
  green400: '#63bf8d',
  green500: '#3caf70',
  green600: '#379f66',
  green700: '#2b7c50',
  green900: '#194a2f',
  yellow50: '#fef8e9',
  yellow200: '#fae09b',
  yellow300: '#f8d26d',
  yellow400: '#fbd437',
  yellow500: '#f4bc25',
  yellow600: '#deab22',
  yellow900: '#664f10',
  blue800: '#1a576a',
  blue900: '#144351',
};

const primary = {
  primary50: '#e7f1fb',
  primary100: '#b5d4f4',
  primary200: '#91c0ee',
  primary300: '#5ea3e6',
  primary400: '#3f91e1',
  primary500: '#0f75da',
  primary600: '#0e6ac6',
  primary700: '#0b539b',
  primary800: '#084078',
  primary900: '#06315c',

  primaryDashboard00: '#f8fbff',
  primaryDashboard50: '#e7f1fb',
  primaryDashboard100: '#d4dfeb',
  primaryDashboard200: '#abb8c6',
  primaryDashboard300: '#8695a5',
  primaryDashboard400: '#667688',
  primaryDashboard500: '#4a5c70',
  primaryDashboard600: '#33465b',
  primaryDashboard700: '#20354b',
  primaryDashboard800: '#12283e',
  primaryDashboard900: '#00162e',
};

const transitionSectorColours = {
  transport50: colourShades.green50,
  transport100: colourShades.green100,
  transport200: colourShades.green200,
  transport300: colourShades.green300,
  transport400: colourShades.green400,
  transport500: colourShades.green500,
  transport600: colourShades.green600,
  transport700: colourShades.green700,
  transport800: colourShades.green800,
  transport900: colourShades.green900,
  transport950: colourShades.green950,
  industry50: colourShades.blue50,
  industry100: colourShades.blue100,
  industry200: colourShades.blue200,
  industry300: colourShades.blue300,
  industry400: colourShades.blue400,
  industry500: colourShades.blue500,
  industry600: colourShades.blue600,
  industry700: colourShades.blue700,
  industry800: colourShades.blue800,
  industry900: colourShades.blue900,
  industry950: colourShades.blue950,
  agriculture50: colourShades.orange50,
  agriculture100: colourShades.orange100,
  agriculture200: colourShades.orange200,
  agriculture300: colourShades.orange300,
  agriculture400: colourShades.orange400,
  agriculture500: colourShades.orange500,
  agriculture600: colourShades.orange600,
  agriculture700: colourShades.orange700,
  agriculture800: colourShades.orange800,
  agriculture900: colourShades.orange900,
  agriculture950: colourShades.orange950,
  energy50: colourShades.yellow50,
  energy100: colourShades.yellow100,
  energy200: colourShades.yellow200,
  energy300: colourShades.yellow300,
  energy400: colourShades.yellow400,
  energy500: colourShades.yellow500,
  energy600: colourShades.yellow600,
  energy700: colourShades.yellow700,
  energy800: colourShades.yellow800,
  energy900: colourShades.yellow900,
  energy950: colourShades.yellow950,
  other50: colourShades.pink50,
  other100: colourShades.pink100,
  other200: colourShades.pink200,
  other300: colourShades.pink300,
  other400: colourShades.pink400,
  other500: colourShades.pink500,
  other600: colourShades.pink600,
  other700: colourShades.pink700,
  other800: colourShades.pink800,
  other900: colourShades.pink900,
  other950: colourShades.pink950,
  waste50: colourShades.teal50,
  waste100: colourShades.teal100,
  waste200: colourShades.teal200,
  waste300: colourShades.teal300,
  waste400: colourShades.teal400,
  waste500: colourShades.teal500,
  waste600: colourShades.teal600,
  waste700: colourShades.teal700,
  waste800: colourShades.teal800,
  waste900: colourShades.teal900,
// exporting purple directly, since we don't have a sector to match with.
// in the future a these will be defined in the theme, then the sector colour consept will be removed from here.
  purple50: colourShades.purple50,
  purple100: colourShades.purple100,
  purple200: colourShades.purple200,
  purple300: colourShades.purple300,
  purple400: colourShades.purple400,
  purple500: colourShades.purple500,
  purple600: colourShades.purple600,
  purple700: colourShades.purple700,
  purple800: colourShades.purple800,
  purple900: colourShades.purple900,
  purple950: colourShades.purple950,
};

export const Colours = {
  ...primary,
  ...transitionSectorColours,
  textPrimary: shades.black900,
  textSecondary: shades.black700,
  /**
   *  Defining content area colours
   */
  contentAreaBackground: shades.white000,
  panelBorder: shades.grey200,
  ...unnamedShades,
};
